module.exports = __webpack_public_path__ + "static/media/web-link.53f82744.svg";